
import { defineComponent, reactive, ref, toRefs, watch } from 'vue'
import { gotoDetail } from '@/utils/stock'
export default defineComponent({
  props: {
    value: {
      type: String,
      default: () => {
        return ''
      }
    },
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    contenteditable: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    disableHuShenStock: {
      type: Boolean,
      default: false
    }
  },
  setup(props: any, context) {
    const pageData = reactive({
      content: '',
      isBlur: true,
      key: Date.now()
    })

    // 判断是否是沪深股票
    function isHuShenStock(marketCode: string) {
      const code = (marketCode || '').toLowerCase()
      return code === 'sh' || code === 'sz'
    }

    watch(
      () => props.value,
      (val: string) => {
        if (typeof val === 'string' && pageData.isBlur) {
          pageData.content = handlecontent(val)
          pageData.key = Date.now()
        }
      },
      {
        immediate: true
      }
    )

    // 监听 disableHuShenStock 变化，重新处理内容
    watch(
      () => props.disableHuShenStock,
      () => {
        if (props.value) {
          pageData.content = handlecontent(props.value)
          pageData.key = Date.now()
        }
      }
    )

    function handleChange(val: any) {
      pageData.content = handlecontent(pageData.content + `$-${val.Name}(${val.Code}.${val.MarketCode})-$`)
    }

    function handlecontent(content: string) {
      let str = content
      // 使用正则匹配股票标签，判断是否需要禁用
      str = str.replace(/\$-([^(]+)\(([^.]+)\.([^)]+)\)-\$/g, (match, name, code, market) => {
        const disabled = props.disableHuShenStock && isHuShenStock(market)
        const className = disabled ? 'contentstock disabled' : 'contentstock'
        return `<span class="${className}" contenteditable="false">${name}(${code}.${market})</span>&nbsp;`
      })
      return str
    }

    const divedit = ref('')
    const MAX_LENGTH = 2048

    function getTextLength(el: HTMLElement): number {
      return (el.innerText || el.textContent || '').length
    }

    function inputcontent(e: any) {
      const el = e.target as HTMLElement
      const textLen = getTextLength(el)
      if (textLen > MAX_LENGTH) {
        const text = (el.innerText || el.textContent || '').slice(0, MAX_LENGTH)
        el.innerText = text
        const range = document.createRange()
        const sel = window.getSelection()
        range.selectNodeContents(el)
        range.collapse(false)
        sel?.removeAllRanges()
        sel?.addRange(range)
      }
      context.emit('input', e.target.innerHTML)
    }

    function stockclick(item: any) {
      const target = item.target
      // 如果是禁用状态，不跳转
      if (target.classList && target.classList.contains('disabled')) {
        return
      }
      const currenstock = target.innerText
      if (target.className && target.className.includes('contentstock')) {
        const data = {
          Exch: currenstock.split('(')[1].split(')')[0].split('.')[1],
          Inst: currenstock.split('(')[1].split(')')[0].split('.')[0]
        }
        gotoDetail(data)
      }
    }

    function handlePaste(e: ClipboardEvent) {
      e.preventDefault()
      const clipboardData = e.clipboardData
      if (!clipboardData) return

      if (clipboardData.files && clipboardData.files.length > 0) {
        return
      }

      let text = clipboardData.getData('text/plain')
      if (text) {
        const el = e.target as HTMLElement
        const currentLen = getTextLength(el)
        const remainingLen = MAX_LENGTH - currentLen
        if (remainingLen <= 0) return
        text = text.slice(0, remainingLen)
        document.execCommand('insertText', false, text)
        context.emit('input', el.innerHTML)
      }
    }

    return {
      ...toRefs(pageData),
      handleChange,
      handlecontent,
      inputcontent,
      stockclick,
      handlePaste
    }
  }
})
